// @flow
/** @jsx jsx */
import React from 'react';
import universal from '@core-ui/universal';
import { jsx, css } from '@core-ui/react-stitch';
import {
  CLEAR_FILTER_BUTTON,
  ITEM_COUNT_ARIA_LABEL,
  ITEM_COUNT_TEXT,
} from '../localization-tokens';
import { localizeItemCount } from '../collaborators/localize-item-count';
import DrawerTopSection from '../styled/DrawerTopSection';
import DrawerMiddleSection from '../styled/DrawerMiddleSection';
// $FlowFixMe
import { BopisBarFragment } from '../bopis-bar-fragment';
// $FlowFixMe
import QuickFilterWrapper from '../../quick-filter-wrapper';

const ClearButton = universal(import('@core-ui/clear-button'), {
  key: 'ClearButton',
});
const FacetBar = universal(import('@cat/facet-bar'), { key: 'default' });
const ItemCount = universal(import('@core-ui/item-count'), {
  key: 'ItemCount',
});
const SortBy = universal(import('@cat/sort-by'));
// $FlowFixMe

export const getLegacyExperience = (props: any) => {
  const {
    totalItemCount,
    mediator,
    publish,
    facetOptions,
    appliedFacets,
    appliedOptions,
    abbrNameForTealium,
    businessUnitId,
    categoryName,
    datalayer,
    pageType,
    selectedNodes,
    webHierarchy,
    localize,
    hasTags,
    sortByValue,
    sortByOnChange,
    isSortByRatingsEnabled,
    abbrBrand,
    isBRRedesignEnabled,
    isBRRedesignOpacityEnabled,
    isSwitchContractEnabled,
    isOutOfStockFilterEnabled,
  } = props;

  const itemCountAriaLabel = localizeItemCount(
    localize,
    ITEM_COUNT_ARIA_LABEL,
    totalItemCount
  );

  const itemCountText = localizeItemCount(
    localize,
    ITEM_COUNT_TEXT,
    totalItemCount
  );

  const getItemCountFragment = (isBRRedesignEnabled) =>
    !isBRRedesignEnabled ? (
      <ItemCount
        position="dashboard"
        key="item-count"
        ariaLabel={itemCountAriaLabel}
        text={itemCountText}
      />
    ) : (
      []
    );

  const quickFilterWrapperParams = {
    facetOptions,
    abbrBrand,
    publish,
    appliedOptions,
    mediator,
    appliedFacets,
  };

  const bopisBarPosition = (isBRRedesignEnabled) =>
    isBRRedesignEnabled ? 'drawer' : 'top';

  return [
    <BopisBarFragment
      position={bopisBarPosition(isBRRedesignEnabled)}
      key="bopis-bar-mobile-legacy"
      abbrNameForTealium={abbrNameForTealium}
      businessUnitId={businessUnitId}
      categoryName={categoryName}
      datalayer={datalayer}
      mediator={mediator}
      pageType={pageType}
      selectedNodes={selectedNodes}
    />,
    <DrawerTopSection
      position="drawer"
      key="drawer-top-section"
      isBRRedesignEnabled={isBRRedesignEnabled}
    >
      <ItemCount ariaLabel={itemCountAriaLabel} text={itemCountText} />
      {hasTags && (
        <ClearButton
          localizedButtonText={localize(CLEAR_FILTER_BUTTON)}
          mediator={mediator}
          accessibleFocusSelector="#facet-bar"
        />
      )}
    </DrawerTopSection>,
    <DrawerMiddleSection
      position="drawer"
      key="drawer-middle-section"
      isBRRedesignEnabled={isBRRedesignEnabled}
    >
      <FacetBar
        facets={facetOptions}
        appliedFacets={appliedFacets}
        isBRRedesignEnabled={isBRRedesignEnabled}
        isSwitchContractEnabled={isSwitchContractEnabled}
      />
    </DrawerMiddleSection>,
    isOutOfStockFilterEnabled && (
      <div position="drawer">{'OUT OF STOCK FILTER ACTIVE'}</div>
    ),
    getItemCountFragment(isBRRedesignEnabled),

    <QuickFilterWrapper
      position="top"
      key="quick-filter-wrapper"
      {...quickFilterWrapperParams}
    />,
    <SortBy
      position="dashboard"
      value={sortByValue}
      onChange={sortByOnChange}
      key="sort-by"
      isSortByRatingsEnabled={isSortByRatingsEnabled}
      isBRRedesignEnabled={isBRRedesignEnabled}
      isBRRedesignOpacityEnabled={isBRRedesignOpacityEnabled}
    />,
  ];
};
